import Blank from "@/layouts/blank.vue";
import NonBondedContainerList from "@/pages/admin/non-bonded-container/NonBondedContainerList.vue";

const nonBondedContainerRoutes = [
  {
    path: "non-bonded-container",
    name: "app-admin-non-bonded-container",
    component: Blank,
    children: [
      {
        path: "/",
        redirect: "/app/admin/non-bonded-container/list",
      },
      {
        path: "list",
        name: "app-admin-non-bonded-container-list",
        component: NonBondedContainerList,
      },
    ],
  },
];

export default nonBondedContainerRoutes;
